/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetDispositionRequestApiModel } from '../../models/set-disposition-request-api-model';
import { SetDispositionResponseApiModel } from '../../models/set-disposition-response-api-model';

export interface SetLeadDisposition$Params {
      body: SetDispositionRequestApiModel
}

export function setLeadDisposition(http: HttpClient, rootUrl: string, params: SetLeadDisposition$Params, context?: HttpContext): Observable<StrictHttpResponse<SetDispositionResponseApiModel>> {
  const rb = new RequestBuilder(rootUrl, setLeadDisposition.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SetDispositionResponseApiModel>;
    })
  );
}

setLeadDisposition.PATH = '/leads/disposition';
